import { render, staticRenderFns } from "./chatResidentes.vue?vue&type=template&id=0cc144d6"
import script from "./chatResidentes.vue?vue&type=script&lang=js"
export * from "./chatResidentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports